// ----------------------------------------------------------------------

export const price = [
  16.19, 35.71, 34.3, 93.1, 55.47, 89.09, 44.39, 26.92, 45.35, 26.96, 78.22,
  35.54, 90.69, 63.61, 67.55, 94.75, 75.78, 39.6, 52.84, 72.8, 83.08, 85.02,
  69.22, 60.96, 84.7, 16.68, 78.83, 58.07, 65.8, 55.69, 87.55, 44.74, 27.42, 84,
  76.17, 43.83, 76.39, 17.42, 42.3, 12.45,
];

export const rating = [
  2.5, 2.2, 4.9, 2.3, 4.0, 5.1, 4.9, 5, 3.7, 2.5, 2, 4.9, 4.8, 4.3, 2, 3.7, 1.4,
  2.4, 1.8, 5.2, 2.9, 3.9, 3.9, 1.8, 5.6, 2.6, 3.1, 3.9, 1.2, 3.2, 4.1, 5.1,
  4.5, 4.1, 2.3, 2.4, 5, 3.1, 4.9, 1.7,
];

export const age = [
  52, 43, 56, 25, 22, 53, 38, 50, 55, 37, 16, 27, 55, 41, 52, 32, 34, 52, 31,
  53, 23, 48, 43, 41, 19, 21, 17, 29, 32, 54, 38, 34, 49, 33, 55, 50, 24, 27,
  23, 23,
];

export const percent = [
  8.62, 86.36, 73.99, 79, 63.41, 58.79, 12.32, 88.44, 45.06, 91.64, 88.41,
  73.08, 39.14, 89.34, 43.37, 34.45, 24.04, 80.96, 72.91, 47.59, 2.46, 3.33,
  99.31, 47.6, 34.09, 50.61, 66.13, 46.69, 92.43, 31.41, 90.85, 36.32, 38.84,
  25.6, 87.61, 1.31, 89.32, 41.23, 85.9, 62.63,
];
